import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type {
  FetchEmailHubPlanParams,
  FetchPlanParams,
  FetchPlansParams,
  ProrationParams,
} from "@/react/helpers/urlHelpers/internalApi/plans";

const proration = (params: ProrationParams) =>
  reactQueryGet(internalApi.plans.proration(params));

const fetch = (params: FetchPlanParams) =>
  reactQueryGet(internalApi.plans.fetch(params));

const fetchPlans = (params: FetchPlansParams = {}) =>
  reactQueryGet(internalApi.plans.fetchPlans(params));

const fetchEmailHubPlan = (params: FetchEmailHubPlanParams) =>
  reactQueryGet(internalApi.plans.fetchEmailHubPlan(params));

export const planApi = {
  proration,
  fetch,
  fetchPlans,
  fetchEmailHubPlan,
};
